/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'file/big/no-file': {
    width: 56,
    height: 56,
    viewBox: '0 0 56 56',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M14.933 4.667H30.6a1 1 0 01.707.293l1.807 1.807h-.011l.472.472L45.1 18.765v-.01l1.807 1.806a1 1 0 01.293.707V46.9a5.6 5.6 0 01-5.6 5.6H14.933a5.6 5.6 0 01-5.6-5.6V10.267a5.6 5.6 0 015.6-5.6zM45.101 20.94H32.875a1.4 1.4 0 01-1.4-1.4V6.767H14.933a3.5 3.5 0 00-3.5 3.5V46.9a3.5 3.5 0 003.5 3.5h26.668a3.5 3.5 0 003.5-3.5V20.941zm-11.526-2.1v-8.633l8.633 8.633h-8.633z" _fill="#1092DC"/><path pid="1" fill-rule="evenodd" clip-rule="evenodd" d="M28.267 25.5a.75.75 0 01.75.75v9.272l3.97-3.97a.75.75 0 011.06 1.061l-5.246 5.247a.747.747 0 01-1.068 0l-5.246-5.247a.75.75 0 011.06-1.06l3.97 3.97V26.25a.75.75 0 01.75-.75zm-6.416 13.416a.75.75 0 000 1.5h12.833a.75.75 0 000-1.5H21.85z" _fill="#1092DC"/>'
  }
})
